var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline is-desktop"},_vm._l((_vm.laptops),function(laptop){return _c('div',{key:laptop.id,class:_vm.columnClass},[_c('ProductCard',{key:laptop.id,attrs:{"laptop":laptop,"awaiting":_vm.awaiting}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }